import styled from 'styled-components';
import { Breakpoints } from '../breakpoints';
import { Input as _Input } from '../components/form.styled';

export const Input = styled(_Input)`
    @media screen and (max-width: ${Breakpoints.mobile}) {
        justify-self: unset;
    }
`;
